// POS gateway-i qlobal axios-a quraşdırır.
// index.tsx-də render-dən ƏVVƏL bir dəfə çağırılır: installPosGateway().
//
// İş prinsipi: POS rejimi aktivdirsə (Electron və ya REACT_APP_POS_MODE=on),
// hər axios sorğusu üçün uyğun POS route axtarılır. Tapılarsa, sorğunun
// `adapter`-i pos_local-a yönləndirən funksiya ilə əvəzlənir — beləliklə
// `axios.get(${base_url}/tables)` çağırışı dəyişmədən pos_local-a gedir.
// Uyğun route yoxdursa sorğu toxunulmadan cloud-a gedir.

import axios, { type AxiosInstance } from 'axios';
import { toast } from '../../components/ui/notify';
import { tStatic } from '../../i18n/I18nContext';
import { POS_ENABLED } from './config';
import { resolvePosAdapter } from './adapter';
import { setPosUnauthorizedHandler } from './posClient';
import type { MatchedConfig } from './types';

let installed = false;

/**
 * pos_local 401 (sessiya bitib/ləğv) → istifadəçini PIN login-ə (staff seçimi, "/")
 * qaytar. Cloud `token`-inə TOXUNMURUQ (yalnız pos_token sıfırlanır posClient-də) —
 * restoran sessiyası qalır, istifadəçi sadəcə PIN-i yenidən daxil edir.
 *
 * Loop qoruması: login ekranındaykən (path "/") yönləndirmə etmirik; paralel
 * sorğuların burst-u bir dəfə yönləndirsin deyə `redirecting` bayrağı var.
 */
function installPosReauthHandler(): void {
  let redirecting = false;
  setPosUnauthorizedHandler(() => {
    if (redirecting) return;
    if (typeof window === 'undefined') return;
    if (window.location.pathname === '/') return; // onsuz da login ekranı
    redirecting = true;
    try {
      toast.warn(tStatic('pos.sessionEnded'));
    } catch {
      /* toast hazır deyilsə əhəmiyyət vermə */
    }
    setTimeout(() => {
      window.location.href = '/';
    }, 900);
  });
}

/**
 * Gateway-i KONKRET axios instansiyasına qoşur.
 *
 * VACİB: `axios.create()` ilə yaradılan instansiya QLOBAL interceptor-ları
 * MİRAS ALMIR — öz zənciri var. Ona görə öz client-i olan hər modul bunu
 * ayrıca çağırmalıdır, əks halda sorğuları pos_local-ı görməyib birbaşa
 * cloud-a gedir.
 *
 * Bu real xətaya səbəb oldu: mətbəx ekranı (`api/kitchen.ts` → `kitchenClient`)
 * cloud KDS-ə sorğu atırdı, POS sifarişləri isə pos_local-da idi → ekran
 * həmişə boş qalırdı.
 *
 * QR menyu client-ləri (qrAdisyon, qrWaiterCall, customerAuth) QƏSDƏN
 * qoşulmur — onlar müştərinin telefonunda işləyir və cloud-a getməlidir.
 */
export function attachPosGateway(instance: AxiosInstance): void {
  if (!POS_ENABLED) return;
  instance.interceptors.request.use((config) => {
    const posAdapter = resolvePosAdapter(config as unknown as MatchedConfig);
    if (posAdapter) {
      (config as { adapter?: unknown }).adapter = posAdapter;
    }
    return config;
  });
}

export function installPosGateway(): void {
  if (installed || !POS_ENABLED) return;
  installed = true;

  installPosReauthHandler();

  attachPosGateway(axios as unknown as AxiosInstance);

  // eslint-disable-next-line no-console
  console.info('[rezmo-pos] gateway aktivdir — POS route-ları pos_local-a yönlənir');
}
